import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { getRuntimeConfig } from '../config/runtimeConfig';

export function getOidcConfig(): UserManagerSettings {
  const { keycloakUrl, keycloakRealm, keycloakClientId } = getRuntimeConfig();

  return {
    authority: `${keycloakUrl}/realms/${keycloakRealm}`,
    client_id: keycloakClientId,
    redirect_uri: `${window.location.origin}/callback`,
    post_logout_redirect_uri: `${window.location.origin}/`,
    response_type: 'code',
    scope: 'openid profile email roles offline_access',

    // Tokens: tab-scoped sessionStorage (cleared on tab close)
    userStore: new WebStorageStateStore({ store: sessionStorage }),
    // PKCE/interaction state: also sessionStorage so tabs don't share in-flight auth state
    // (library default is localStorage)
    stateStore: new WebStorageStateStore({ store: sessionStorage }),

    // Automatically refresh tokens via SilentRenewService
    automaticSilentRenew: true,
    silent_redirect_uri: `${window.location.origin}/silent-renew`,

    // PKCE is enabled by default in oidc-client-ts

    // Metadata URL (optional, oidc-client-ts can discover this)
    // metadataUrl: `${keycloakUrl}/realms/${keycloakRealm}/.well-known/openid-configuration`,
  };
}
